<template>
  <div class="step-conditions-editor">
    <div class="toolbar">
      <el-button type="primary" size="small" @click="addCondition">添加条件</el-button>
    </div>
    <el-table :data="conditions" border style="margin-top: 10px">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="条件类型" prop="conditionType" width="150">
        <template slot-scope="scope">
          <el-select
            :value="scope.row.conditionType"
            @change="updateCondition(scope.$index, 'conditionType', $event)"
            placeholder="请选择条件类型"
          >
            <el-option
              v-for="option in conditionTypeOptions"
              :key="option.value"
              :label="option.label || option.value"
              :value="option.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="匹配值" prop="matchValue" v-if="showMatchValue">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.matchValue"
            @input="updateCondition(scope.$index, 'matchValue', $event)"
            placeholder="请输入匹配值"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="表达式" prop="expression" v-if="showExpression">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.expression"
            @input="updateCondition(scope.$index, 'expression', $event)"
            type="textarea"
            :rows="2"
            placeholder="请输入表达式，如: #sendSuceess == true"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="下一步ID" prop="nextStepId" width="150">
        <template slot-scope="scope">
          <el-select
            :value="scope.row.nextStepId"
            @change="updateCondition(scope.$index, 'nextStepId', $event)"
            filterable
            clearable
            placeholder="请选择下一步或输入新ID"
          >
            <el-option
              v-for="step in stepOptions"
              :key="step.stepId"
              :label="step.label"
              :value="step.stepId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="优先级" prop="priority" width="200">
        <template slot-scope="scope">
          <el-input-number
            :value="scope.row.priority"
            @input="updateCondition(scope.$index, 'priority', $event)"
            :min="1"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="removeCondition(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StepConditionsEditor",
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
  inject: {
    getEditingStepData: {
      from: "getEditingStepData",
      default: () => () => null
    },
    updateEditingStepField: {
      from: "updateEditingStepField",
      default: () => () => {}
    }
  },
  computed: {
    ...mapGetters("problemFlowConfig", ["steps", "stepIds", "stepOptions", "conditionTypeOptions"]),
    conditions() {
      // 优先使用临时编辑状态，否则使用 store 中的数据
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        return editingStepData.conditions || [];
      }
      return this.steps[this.stepId]?.conditions || [];
    },
    allStepIds() {
      return this.stepIds;
    },
    showMatchValue() {
      return this.conditions.some((c) => c.conditionType === "EQUALS");
    },
    showExpression() {
      return this.conditions.some((c) => c.conditionType === "EXPRESSION");
    }
  },
  methods: {
    updateConditions(newConditions) {
      // 优先更新临时编辑状态，否则直接更新 store
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        this.updateEditingStepField("conditions", newConditions);
      } else {
        this.$store.dispatch("problemFlowConfig/updateStepField", {
          stepId: this.stepId,
          field: "conditions",
          value: newConditions
        });
      }
    },
    addCondition() {
      const conditions = [...this.conditions];
      conditions.push({
        conditionType: "EQUALS",
        matchValue: "",
        nextStepId: "",
        priority: conditions.length + 1
      });
      this.updateConditions(conditions);
    },
    removeCondition(index) {
      const conditions = [...this.conditions];
      conditions.splice(index, 1);
      this.updateConditions(conditions);
    },
    updateCondition(index, field, value) {
      const conditions = [...this.conditions];
      conditions[index] = { ...conditions[index], [field]: value };
      this.updateConditions(conditions);
    }
  }
};
</script>

<style lang="less" scoped>
.step-conditions-editor {
  padding: 10px;
  overflow-x: auto;
}
</style>
